'use strict';

export default class SearchResults {
    constructor(options) {
        console.log('SearchResults module');

        const defaults = {
            acInputs: '.searchResults input[type="text"]',

            endPoint: '/search/map/functions',

            searchResults: '.searchResults',
            searchResultsElem: '.searchResults__body',
            searchResultsList: '#searchResults__list',
            searchResultsItem: '.searchResults__item',
            searchResultsCount: '.searchResults__number',
            searchResultsCounters: {
                aide: {
                    className: '.searchResults__splitCount.aide',
                    text: 'agence'
                },
                MR: {
                    className: '.searchResults__splitCount.MR',
                    text: 'maison'
                },
                RS: {
                    className: '.searchResults__splitCount.RS',
                    text: 'résidence'
                }
            },
            templateEngine: null,

            tabs: {
                module: '.tabs',
                toggler: '.tabs__toggle',
                item: '.tabs__item',
            },

            selects: {
              searchType: '.tabs select[name="type"]',
              searchService: '.tabs select[name="service"]',
              searchLogement: '.tabs select[name="type_de_logement"]',
              searchRecherchez: '.tabs select[name="vous_recherchez"]'
            },

            submitButton: '.tabs button[type="submit"]',
            searchInput: '#location',

            resultsTemplate: '' +
              '<ul class="searchResults__list" id="searchResults__list">'+
                '<%for(var index in this.data) {%>' +
                  '<li class="searchResults__item <%this.data[index].ss_field_establishment_type%>" style="transition: box-shadow 300ms linear, transform 240ms ease <%index*78%>ms, opacity 240ms linear <%index*78%>ms">'+
                    '<div class="searchResults__image">'+
                      '<%if(typeof(this.data[index].ss_field_establishment_block_image) != "undefined") {%>' +
                        '<a target="_blank" href="<%this.data[index].ss_url%>">' +
                          '<img src="<%this.data[index].ss_field_establishment_block_image%>" alt="<%this.data[index].ss_title%>">'+
                        '</a>'+
                      '<%}else if(typeof(this.data[index].sm_field_establishment_image_url) != "undefined") {%>' +
                        '<a target="_blank" href="<%this.data[index].ss_url%>">' +
                          '<img src="<%this.data[index].sm_field_establishment_image_url[0]%>" alt="<%this.data[index].ss_title%>">'+
                        '</a>'+
                      '<%}%>'+
                    '</div>'+
                    '<div class="searchResults__info">'+
                    '<a target="_blank" href="<%this.data[index].ss_url%>">' +
                      '<div class="searchResults__title"><%this.data[index].ss_title%></div>'+
                      '<div class="searchResults__address"><%this.data[index].ss_field_code_postal%> <%this.data[index].ss_field_ville%></div>'+
                    '</a>'+
                      '<%if(typeof(this.data[index].ss_field_presentation) != "undefined") {%>' +
                        '<div class="searchResults__text"><%this.data[index].ss_field_presentation.substring(0, 120) + "..."%></div>'+
                      '<%}%>'+
                      '<%if(this.data[index].ss_field_establishment_type == "AAD") {%>' +
                        '<button type="button" class="searchResults__button">Voir cette agence</button>'+
                      '<%}else{%>'+
                        '<button type="button" class="searchResults__button">Voir cette résidence</button>'+
                      '<%}%>'+
                    '</div>'+
                  '</li>'+
                '<%}%>'+
            '</ul>',

            iwTemplate: '' +

            '<div class="infoWindow">' +
                '<h5 class="infoWindow__title <%this.data.typeofHouse%>"><%this.data.title%></h5>'+
                '<div class="infoWindow__body">'+
                  '<p class="infoWindow__stablishmentType"><%this.data.typeofHouseLong%></p>'+
                  '<br/><div class="infoWindow__address <%this.data.typeofHouse%>"><%this.data.rue%> <br/> <%this.data.ville%> <%this.data.postalCode%></div>'+

                  '<%if(this.data.typeofHouse == "AAD") {%>' +
                    '<a href="<%this.data.url%>" class="infoWindow__call">Voir cette agence</a>'+
                  '<%}else{%>'+
                    '<a href="<%this.data.url%>" class="infoWindow__call">Voir cette résidence</a>'+
                  '<%}%>'+

                '</div>' +
            '</div>'
        };

        this.options = Object.assign({}, defaults, options);

        //ac things
        this.ac = [];
        this.searchType = null;
        this.searchValue = null;

        //map things
        this.bounds = new google.maps.LatLngBounds();
        this.geocodeAnswer = false;
        this.map_options = {
            mapTypeId: google.maps.MapTypeId.ROADMAP //set map type to road map
        };
        this.map = new google.maps.Map(document.getElementById("map-canvas"), this.map_options);
        this.increasedSearch;
        this.markers_array = []; //this will store an array of the markers that were created
        this.input = document.getElementById('location');

        //filter things
        this.resultsPerType = {
            aide: 0,
            MR: 0,
            RS: 0
        };
        this.urlToFollow = null;
        this.searchValue = null;

        this.searchValue = null; //autocomplete value
        this.searchType = null; //House type or aide a domicile
        this.searchService = null; //aide a domicile services
        this.searchLogement = null; //RS types
        this.searchRecherchez = null;//MR types
        this.departementParams = false;

        if(defaults.endPoint !== this.options.endPoint) {
            //is departement page

            // @todo: tá feio, precisa arrumar :D
            var uri = this.options.uri.getSegments()[1];
            var department_without_params = uri.replace(window.location.search, "");

            this.departementParams = {
                searchType: this.options.uri.getSegments()[0],
                departement: department_without_params,
                area: department_without_params.split('-').splice(-1)
            }


            $(this.input).hide().val(this.departementParams.departement + ',France');

        }
        //init polygon
        this.polygon = new google.maps.Polygon;
        this.polygons_array = []; //this will store an array of the polygons
        this.polygons_legend = []; //this will store color and service for legend
        this.polygon_colors = ['#cc2229','#29844d'];

        //auto init
        this._drawMap();
        this._listemForm();
        this._followLink();

    }

    _followLink() {
      $(this.options.searchResultsItem).each(function(i) {
        $(this).on('click', function(evt) {
          var win = window.open($(this).find('a').attr('href'), '_blank');
          win.focus();
        });
      });
    }

    _pacSelectFirst(input) {
        // store the original event binding function
        var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

        function addEventListenerWrapper(type, listener) {
            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
            // and then trigger the original listener.
            if (type == "keydown") {
                var orig_listener = listener;
                listener = function(event) {
                    var suggestion_selected = $(".pac-item-selected").length > 0;
                    if (event.which == 13 && !suggestion_selected) {
                        var simulated_downarrow = $.Event("keydown", {
                            keyCode: 40,
                            which: 40
                        });
                        orig_listener.apply(input, [simulated_downarrow]);
                    }

                    orig_listener.apply(input, [event]);
                };
            }

            _addEventListener.apply(input, [type, listener]);
        }

        input.addEventListener = addEventListenerWrapper;
        input.attachEvent = addEventListenerWrapper;
    }

    _listemForm() {

      $.each(this.options.selects, function(i, obj) {

        $(obj).on('change', function(evt) {
          evt.preventDefault();
          this._changeUrl();
        }.bind(this)).trigger('change', true);

      }.bind(this));

      $(this.options.acInputs).on('keyup change keypress', function(evt) {

        if (evt.which == 13 ) {
            evt.preventDefault();
        }

        setTimeout(function(){
            this._changeUrl();
        }.bind(this), 200);

      }.bind(this));

      $(this.options.tabs.item).on('click touchend', function (evt) {
            setTimeout(function() {
                $(this.options.selects.searchType + ' option[value='+ $(this.options.tabs.toggler).filter(':checked').val() +']').prop('selected', true);
                $(this.options.selects.searchType).trigger('change', true)
            }.bind(this), 300)
        }.bind(this));

      $(this.options.submitButton).on('click touchend', function(evt) {
        document.cookie = "service_selected="+this.searchService;
          evt.preventDefault();
          if(this.searchValue !== '') {
            $('.form').attr('action', this.urlToFollow.replace(',France', '')).submit();
            $('.form').submit();
          } else {
            $(this.options.acInputs).focus();
          }
      }.bind(this));

    }

    _changeUrl() {

      this.searchValue = $(this.options.acInputs).val(); //autocomplete value
      this.searchType = $(this.options.selects.searchType).val(); //House type or aide a domicile
      this.searchService = this._getServiceTrueValue();
      this.searchLogement = $(this.options.selects.searchLogement).val(); //RS types
      this.searchRecherchez = $(this.options.selects.searchRecherchez).val();//MR types

      this.urlToFollow = window.location.origin + '/' +
                         this._getHouseTypeUrl() +
                         this.searchValue;

      switch(this.searchType){

        case 'mr_search_string':
        if(this.searchRecherchez !== '')
            this.urlToFollow += "/recherchez/" + this.searchRecherchez;
        break;

        case 'rs_search_string':
        if(this.searchLogement !== '')
            this.urlToFollow += "/logement/" + this.searchLogement;
        break;

        case 'ad_search_string':
        if(this.searchService !== '')
            this.urlToFollow += "/service/" + this.searchService;
        break;

        default:
        break;
      }

    }

    _getServiceTrueValue(valTrue = false){
      let serviceCompare = $(this.options.selects.searchService).val();
      let aideSSIADServices = ['Service de soins infirmiers'];
      if(valTrue && serviceCompare == "") {
        return "tous";
      } else if(serviceCompare == "") {
        return "";
      }
      if(aideSSIADServices.indexOf(serviceCompare) != -1) {
          return "SSIAD";
      } else {
          return "MAD";
      }
    }

    _getHouseTypeUrl() {

      $(this.options.tabs.toggler).attr('checked', false);

      $(this.options.selects.searchService).parent().hide();
      $(this.options.selects.searchLogement).parent().hide();
      $(this.options.selects.searchRecherchez).parent().hide();

      let rechercheString = (this.departementParams) ? '' : 'recherche/';

      switch(this.searchType){
        case 'tous_search_string':
            $(this.options.tabs.toggler).eq(0).prop("checked", true);
            return rechercheString + 'tous/';
        break;

        case 'mr_search_string':
            $(this.options.tabs.toggler).eq(1).prop("checked", true);
            $(this.options.selects.searchRecherchez).parent().show();
            return rechercheString + 'maisons-de-retraite/';
        break;

        case 'rs_search_string':
            $(this.options.tabs.toggler).eq(2).prop("checked", true);
            $(this.options.selects.searchLogement).parent().show();
            return rechercheString + 'residence-seniors/';
        break;

        case 'ad_search_string':
            $(this.options.tabs.toggler).eq(3).prop("checked", true);
            $(this.options.selects.searchService).parent().show();
            return rechercheString + 'aide-a-domicile/';
        break;

        default:
            $(this.options.tabs.toggler).eq(0).prop("checked", true);
            return rechercheString + 'tous/';
        break;
      }

    }

    _splitResultsSize(places) {

        this.resultsPerType.aide = 0;
        this.resultsPerType.MR = 0;
        this.resultsPerType.RS = 0;

        for (var i = places.length - 1; i >= 0; i--) {
            switch(places[i].ss_field_establishment_type) {

                case 'AAD':
                this.resultsPerType.aide ++;
                break;

                case 'EHPAD':
                this.resultsPerType.MR ++;
                break;

                case 'Résidence Sénior':
                this.resultsPerType.RS ++;
                break;

                default:
                break;
            }
        }

        return this;
    }

    _updateSplitedCounters() {
        if(this.resultsPerType.aide <= 0) {
            $(this.options.searchResultsCounters.aide.className).parent('div').hide();
        } else {
            $(this.options.searchResultsCounters.aide.className).parent('div').show();
            $(this.options.searchResultsCounters.aide.className).find('.searchResults__size').text(this.resultsPerType.aide);
            $(this.options.searchResultsCounters.aide.className).find('.searchResults__text').text(this.options.searchResultsCounters.aide.text + ((this.resultsPerType.aide > 1) ? 's': ''));
        }

        if(this.resultsPerType.MR <= 0) {
            $(this.options.searchResultsCounters.MR.className).parent('div').hide();
        } else {
            $(this.options.searchResultsCounters.MR.className).parent('div').show();
            $(this.options.searchResultsCounters.MR.className).find('.searchResults__size').text(this.resultsPerType.MR);
            $(this.options.searchResultsCounters.MR.className).find('.searchResults__text').text(this.options.searchResultsCounters.MR.text + ((this.resultsPerType.MR > 1) ? 's': ''));
        }

        if(this.resultsPerType.RS <= 0) {
            $(this.options.searchResultsCounters.RS.className).parent('div').hide();
        } else {
            $(this.options.searchResultsCounters.RS.className).parent('div').show();
            $(this.options.searchResultsCounters.RS.className).find('.searchResults__size').text(this.resultsPerType.RS);
            $(this.options.searchResultsCounters.RS.className).find('.searchResults__text').text(this.options.searchResultsCounters.RS.text + ((this.resultsPerType.RS > 1) ? 's': ''));
        }

    }

    _hidrateResults(places) {

      let htmlToDOM = this.options.templateEngine.Render(this.options.resultsTemplate, {data: places});

      $(this.options.searchResultsCount).text(places.length);
      $(this.options.searchResultsElem).html(htmlToDOM);

      $(document).find(this.options.searchResultsList).easyPaginate({
        paginateElement: 'li',
        elementsPerPage: 200
      });

      this._followLink();

      setTimeout(function(){
        $('body').removeClass('is-loading');
      }.bind(this), 150);
    }

    _handleZoomChanged() {
        console.log("zoom_changed");
        this._handleBounds();
    }

    _handleBounds() {
        if (this.map.getBounds()) {
            this.bounds = this.map.getBounds();
        }
        google.maps.event.addListenerOnce(this.map, 'idle', function() {
            if (this.increasedSearch) {
                this.increasedSearch = false;
            } else {
                this._updateMap(this.geocodeAnswer);
            }
            this.geocodeAnswer = false;
        }.bind(this));
    }

    _handleDragendChanged() {
        console.log("dragend");
        this._handleBounds();
    }

    _handleGeocodingResponse(results, status) {
        var numResults = results.length;

        if (numResults == 0) {
            return;
        }

        var result = results[0];

       // Quand un utilisateur fait une recherche via l'url avec un code postal précis on affiche les résultats de ville de cette recherche.
        if (result.types[0] === "postal_code" || result.types[0] === "street_address") {
          for (var i = 0; i < result.address_components.length; i += 1) {
           var addressObj = result.address_components[i];
           for (var j = 0; j < addressObj.types.length; j += 1) {
      if (addressObj.types[j] === 'locality') {
          console.log("User searched for street address -now letz search for: " + addressObj.long_name);
          this.geocoder.geocode({
              address: addressObj.long_name,
              componentRestrictions: {
                country: 'FR'
              }
          }, this._handleGeocodingResponse.bind(this));
          return;
      }
     }
   }
  }

        this.locationLatLng = result.geometry.location;

        if (result.geometry.bounds) {
            console.log("geometry bound found");
            this.bounds.extend(result.geometry.bounds.getNorthEast());
            this.bounds.extend(result.geometry.bounds.getSouthWest());

        }
        if (result.geometry.viewport) {
            console.log("geometry viewport found");
            this.bounds.extend(result.geometry.viewport.getNorthEast());
            this.bounds.extend(result.geometry.viewport.getSouthWest());
        }
        this._fitMap(this.bounds, true); //automatically adjust the display on the viewport
    }

    _fitMap(bounds, geocodeResult) {
        var mapDim = {
            height: 468,
            width: 726
        };
        var WORLD_DIM = {
            height: 256,
            width: 256
        };
        var ZOOM_MAX = 21;

        function latRad(lat) {
            var sin = Math.sin(lat * Math.PI / 180);
            var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }

        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();

        var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

        var lngDiff = ne.lng() - sw.lng();
        var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

        var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
        var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

        var zoom = Math.min(latZoom, lngZoom, ZOOM_MAX);

        this.geocodeAnswer = geocodeResult;

        if(['Rhône, France', 'rhone-69,France'].includes($(this.options.searchInput).val())) {
            //pls see: DVP-383
            zoom = 10;
        }

        if($(this.options.searchInput).val() == 'hauts-de-seine-92,France') {
          //pls see: DVP-383
          zoom = 11;
        }

	if($(this.options.searchInput).val() == 'seine-saint-denis-93,France') {
          zoom = 11;
        }

        this.map.setCenter(this.locationLatLng);
        this.map.setZoom(zoom);
    }

    _updateMap(geocodeResult) {
        this._closeIWs();

          var data = {
          'ne': this.bounds.getNorthEast().toUrlValue(),
          'sw': this.bounds.getSouthWest().toUrlValue(),
          'center': this.locationLatLng.toUrlValue(),
          'geocodeResult': geocodeResult,
          'type': this.search_type,
          'place': this.search_place,
          'department': this.search_department,
          'service': this.search_service,
          'service_value': this.search_service_value,
          'raw_url': window.location.href
      };

        if(['Rhône, France', 'rhone-69,France'].includes($(this.options.searchInput).val())) {
            //pls see: DVP-383
            data.ne = "45.970736,5.34585";
            data.sw = "45.522241,4.347467";
            data.center = "45.746488,4.846658";

            // ne:45.970736,5.34585
            // sw:45.522241,4.347467
            // center:45.746488,4.846658
        }

        //make the request
        $('body').addClass('is-loading');
        $.post(this.options.endPoint, (this.departementParams) ? Object.assign({}, this.departementParams, data) : data, function(response) {

            var results = JSON.parse(response); //convert the JSON string to a JavaScript object
            if (results.response) {

                var places = results.response.docs; //the actual places that were returned by solr

                var search_url = window.location.href.split('/');

              if(search_url.length < 6){ // permet de filtrer sur l'url (elimination de l'url via la barre de recherche)
                var urlFormatee = search_url[4].split("-");
                var nomVille = urlFormatee[0];

             if ((urlFormatee[1].length) == 5) { // On verifie via l'url si on recherche un departement ou via un code postal
                 // Filtre pour récupérer les residences ayant comme field ville le nom de la ville présente dans l'url
                places = places.filter(x => x.ss_field_ville.toLowerCase().includes(nomVille.toLowerCase()));
              }
              }
                var place_count = places.length;

                this._hidrateResults(places);
                this._splitResultsSize(places)._updateSplitedCounters();

                if(place_count <= 0) {
                    $('body').addClass('no-results');
                } else {
                    $('body').removeClass('no-results');

                    this.iw = [];
                }

                //loop through all the places that were returned
                this.marker = [];
                this.iw = [];

                for (var x = 0; x < place_count; x++) {
                    if(typeof(places[x]['locs_field_coordinates_geofield$latlon']) == "undefined") continue;


                    console.log(places[x]);
                    let typeofHouse = places[x].ss_field_establishment_type.replace(/[^A-Z0-9]/ig, "_");

                    var coordinate = (places[x]['locs_field_coordinates_geofield$latlon']).split(','); //convert the string to an array
                    var lat = coordinate[0];
                    var lng = coordinate[1];

                    //create the marker which points out the nearby places
                    this.marker[x] = new google.maps.Marker({
                        parent: this, // needs revision,pls
                        position: new google.maps.LatLng(lat, lng),
                        map: this.map,
                        nid: places[x]['is_nid'],
                        type: places[x]['ss_field_establishment_type'],
                        title: places[x]['ss_title'],
                        postalCode: places[x]['ss_field_code_postal'],
                        ville: places[x]['ss_field_ville'],
                        rue: places[x]['ss_field_rue'],
                        url: places[x]['ss_url'],
                        idx: x,
                        typeofHouse: typeofHouse, //needed to reset all pins for initial image
                        icon: window.location.origin + '/sites/all/themes/salse/images/pin_'+typeofHouse+'.png'
                    });

                    this.iw[x] = new google.maps.InfoWindow({
                      content: this._buildIWTemplate(this.marker[x])
                    });

                    google.maps.event.addListener(this.map, 'click', function(evt) {
                        this._closeIWs();
                    }.bind(this));

                    google.maps.event.addListener(this.marker[x], 'click', function() {

                        this.parent._closeIWs();
                        this.parent.map.resetMarkersIcon();
                        this.parent._changeMarkerIcon(this);

                        this.parent.iw[this.idx].open(this.map, this);

                        if(this.type !== 'AAD') return;
                        this.parent._getPolygon(this.nid, $(this.parent.options.selects.searchService).val());
                    });

                    //push the marker to the array which stores the markers so we can clear them later
                    //when user moves the slider again
                    this.markers_array.push(this.marker[x]);

                    if (results.updateMap) {
                        this.bounds.extend(this.marker[x].getPosition());
                    }

                }

                if (results.updateMap) {
                    this.map.fitBounds(this.bounds);
                    $(".increasedResearch").show();
                    this.increasedSearch = true;
                    //this._fitMap(this.bounds, false);
                }
            }


        }.bind(this));
    }

    _clearPins() {
        for (var i = 0; i < this.markers_array.length; i++) {
          this.markers_array[i].setMap(null);
        }
    }

    _buildIWTemplate(data) {

        data.typeofHouseLong = 'Résidence senior';
        if (data.typeofHouse == 'AAD') {

            data.typeofHouseLong = 'Aide à domicile';
            data.title = 'Agence ' + data.title;
        } else if(data.typeofHouse == 'EHPAD') {
            data.typeofHouseLong = 'Maison de retraite';
        }

        let htmlToDOM = this.options.templateEngine.Render(this.options.iwTemplate, {data: data});

        return htmlToDOM;
    }

    _closeIWs() {

        if(!this.iw) return;

        for (var i = this.iw.length - 1; i >= 0; i--) {
            this.iw[i].close();
        }
    }

    _getPolygon(nid, Activitie) {
        this._showLoading();

        $.get('/services/session/token', function (response) {
            this._polygons(response, nid, Activitie)
        }.bind(this));
    }

    _createPolygon(coords, color) {
        this.polygon = new google.maps.Polygon({
            paths: coords,
            strokeWeight: 0,
            fillColor: color,
            fillOpacity: 0
        });
        this.polygon.setMap(this.map);
        this.polygons_array.push(this.polygon);

        this._animatePolygon(this.polygon);
    }

    _animatePolygon(polygon) {
        var opacity = 0;
        var interval = window.setInterval(function() {
            polygon.set('fillOpacity', opacity);
            opacity = opacity + 0.1;
            if(opacity > 0.4){
                clearInterval(interval);
            }
        }, 80);
    }

    _getColor(i) {
        return this.polygon_colors[i];
    }

    _showLoading() {
        document.getElementById("map-canvas").classList.add("loading");
    }

    _hideLoading(){
        setTimeout(function() {
            document.getElementById("map-canvas").classList.remove("loading");
        }, 600);
    }

    _changeMarkerIcon(marker) {
        setTimeout(function(){
            marker.set('icon', window.location.origin + '/sites/all/themes/salse/images/pin_'+marker.typeofHouse+'_active.png');
        }, 600);
    }

    _clearPolygonLegend(){
        this.polygons_legend = [];
    }

    _addPolygonLegend(name, color) {
        this.polygons_legend.push({color: color, legend: name});
    }

    _polygons(token, nid, activitie) {
        var self = this;
        var polygonCoords;
        var activitie_index;
        var polygons_legend;



        var jqxhr = $.ajax({
            url :"/api/establishments/node/"+ nid + '/?polygon=on',
            method: "GET",
            headers: {'X-CSRF-Token': token }
        })
        .error(function(){
            self._hideLoading();
        })
        .done(function(data) {
            self.map.clear_polygons();
            self._clearPolygonLegend();
            activitie_index = 0;

            var activities = data.field_activities;
            let selectedText = $(self.options.selects.searchService).find('option:selected').text();
            let legendText;

            activities.map(function(activitie) {

                var polygon_color;

                if(self._getServiceTrueValue() != "" ){
                    if(activitie.name !== self._getServiceTrueValue()) {
                        self._hideLoading();
                        return;
                    }
                }

                if(selectedText == 'Vous recherchez') {
                    if(activitie.name == 'MAD') {
                        polygon_color = "red";
                        legendText = "Zone d'intervention des <br/> services d'aide à domicile";
                    } else {
                        polygon_color = "green";
                        legendText = "Zone d'intervention des <br/> services de soins infirmiers <br/>  à domicile (SSIAD)";
                    }
                    self._addPolygonLegend(legendText, polygon_color);

                } else {
                    self._addPolygonLegend(selectedText, polygon_color);
                }

                activitie.zones.map(function(zone) {
                    polygonCoords = [];
                    zone.coords.map(function(coord) {
                        var polygonCoord = {
                            'lat': parseFloat(coord.lat),
                            'lng': parseFloat(coord.long)
                        };
                        polygonCoords.push(polygonCoord);
                    });
                    self._createPolygon(polygonCoords, polygon_color);
                });
            });
            self._hideLoading();
            self._createLegend();
        });
    }

    _createLegend() {
        var el = document.getElementById('map-legend');
        el.innerHTML = '';

        this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].clear();

        for(var i = 0; i < this.polygons_legend.length; i++) {
            var div = document.createElement('div');
            div.innerHTML = '<span style="background-color:'+this.polygons_legend[i].color+'"></span>' + this.polygons_legend[i].legend;
            el.appendChild(div);
        }

        this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(el);
    }

    _getFilteredAddress() {

        //pls see: DVP-383
        return $(this.options.searchInput).val();
    }

    _drawMap() {

        let acOptions = {
            componentRestrictions: {country: "fr"}
        };

        this._pacSelectFirst(this.input);

        this.autocomplete = new google.maps.places.Autocomplete(this.input, acOptions); //google maps autocomplete
        this.geocoder = new google.maps.Geocoder();

        this.geocodeAnswer = false;
        this.increasedSearch = false;

        /*
         executed when a place is selected from the search bar
         this will automatically adjust the map settings to display the place that was entered in the text field
         */
        if (this.map == null) {
            this.map = new google.maps.Map(document.getElementById("map-canvas"), this.map_options);
            this.map.addListener('dragend', this._handleDragendChanged.bind(this));
            this.map.addListener('zoom_changed', this._handleZoomChanged.bind(this));
        }


        google.maps.event.addListener(this.autocomplete, 'place_changed', function() {
            this._changeUrl();

        }.bind(this));


        google.maps.Map.prototype.clear_markers = function() {
            console.log("clear");
            for (var i = 0; i < this.markers_array.length; i++) {
                this.markers_array[i].setMap(null);
            }
            this.markers_array = [];
            this.bounds = new google.maps.LatLngBounds();
        }.bind(this);

        google.maps.Map.prototype.resetMarkersIcon = function() {
            for (var i = 0; i < this.markers_array.length; i++) {
                this.markers_array[i].set('icon', window.location.origin + '/sites/all/themes/salse/images/pin_'+this.markers_array[i].typeofHouse+'.png');
            }
        }.bind(this);

        google.maps.Map.prototype.clear_polygons = function() {
            for (var i = 0; i < this.polygons_array.length; i++) {
                this.polygons_array[i].setMap(null);
            }
            this.polygons_array = [];
        }.bind(this);


        var search_url = window.location.href.split('/');

        if (search_url.length > 4 && search_url[3] == "recherche") {
            this.search_type = search_url[4];
            this.search_place = search_url[5];
            if (search_url[6]) {
                this.search_service = search_url[6];
            }
            else{
                this.search_service = "";
            }
            if (search_url[7]) {
               this.search_service_value = search_url[7];
            }
            else{
                this.search_service_value = "";
            }
        }

        if(search_url[3] != "recherche"){
            this.search_type = search_url[3];
            this.search_department_value = search_url[4].split("-");
              this.search_department = this.search_department_value[this.search_department_value.length -1];
        }
        google.maps.event.trigger(this.autocomplete, 'place_changed');
        this.map.addListener('dragend', this._handleDragendChanged.bind(this));
        this.map.addListener('zoom_changed', this._handleZoomChanged.bind(this));
        this.geocoder.geocode({
            address: this._getFilteredAddress(),
            componentRestrictions: {
              country: 'FR'
            }
        }, this._handleGeocodingResponse.bind(this));
    }

}
